export default __webpack_public_path__ + "static/media/logo.3558f6e2.png";